export const SET_POSITION_FILTER = 'SET_POSITION_FILTER'
export const REFRESH_POSITION_FILTER = 'REFRESH_POSITION_FILTER'
